import CONTRATO_CATALOGO_CONCEPTOS from '@/graphql/querys/administracion/contratos/catalogoConceptos/contratoCatalogoConceptosPartidas.gql';
import CONTRATO_REPORTES_FISICOS_TODOS from '@/graphql/querys/administracion/ejecucion/reportesFisicos/contratosReportesFisicosTodos.gql';
import AGREGAR_CONTRATO_REPORTE_FISICO from '@/graphql/mutations/administracion/ejecuccion/reportesFisicos/agregarContratoReporteFisico.gql';
import CONTRATO_REPORTES_FISICOS from '@/graphql/querys/administracion/ejecucion/reportesFisicos/contratoReportesFisicos.gql';
import ACTUALIZAR_CONTRATO_REPORTE_FISICO from '@/graphql/mutations/administracion/ejecuccion/reportesFisicos/actualizarContratoReporteFisico.gql';
import ACTUALIZAR_CONTRATO_REPORTE_FISICO_COMENTARIOS_DIRECCION from '@/graphql/mutations/administracion/ejecuccion/reportesFisicos/actualizarContratoReporteFisicoComentariosDireccion.gql';
import REMOVER_CONTRATO_REPORTE_FISICO from '@/graphql/mutations/administracion/ejecuccion/reportesFisicos/removerContratoReporteFisico.gql';

export default {
  apollo: {
    contratoCatalogoConceptosPartidas: {
      query: CONTRATO_CATALOGO_CONCEPTOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    async mixGuardar() {
      const { idContrato } = this.$route.params;
      const { reporteFisico } = this;
      this.enviandoFormulario = true;
      this.mixEsCargando();

      // Obtener partidas
      const { partidas } = reporteFisico;

      // Subir las imagenes
      await Promise.all(
        partidas
          .map((partida) => {
            // Crear nueva partida
            const nuevaPartida = partida;

            if (nuevaPartida.imagenes.length <= 0) {
              nuevaPartida.imagenes = null;
            }

            return nuevaPartida;
          })
          // Filtrar partidas que tengan imagenes
          .filter(({ imagenes }) => imagenes !== null)
          .map(async (partida) => {
            // Crear nueva partida
            const nuevaPartida = partida;
            // Subir las imagenes
            const imagenes = await this.mixSubirImagenes(partida.imagenes);
            // Si se subieron las imagenes
            if (imagenes) {
              nuevaPartida.imagenes = JSON.stringify(imagenes);
            }
            // Regresar la nueva partida
            return nuevaPartida;
          }),
      );

      // set Avance programado
      this.reporteFisico.avanceProgramado = this.getAvanceProgramado;
      // set Avance Fisico
      this.reporteFisico.avanceFisico = this.getSumarAvancePoderado;
      // set Avance Financiero
      this.reporteFisico.avanceFinanciero = this.getAvanceFinanciero;

      // Guardar el reporte
      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_REPORTE_FISICO,
          variables: { reporteFisico },
          update: (store, { data: { agregarContratoReporteFisico } }) => {
            const query = {
              query: CONTRATO_REPORTES_FISICOS,
              variables: { idContrato },
            };
            const { contratoReportesFisicos } = store.readQuery(query);
            const contratoReportesFisicosCopia = contratoReportesFisicos.slice();
            contratoReportesFisicosCopia.push(agregarContratoReporteFisico);
            store.writeQuery({
              ...query,
              data: {
                contratoReportesFisicos: contratoReportesFisicosCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
          this.cerrar();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      await this.$apollo.queries.contratoCatalogoConceptosPartidas.refetch({
        idContrato,
      });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },

    async mixActualizar() {
      const { idContrato } = this.$route.params;
      const { reporteFisico } = this;

      this.enviandoFormulario = true;
      this.mixEsCargando();

      const { partidas } = reporteFisico;

      // Subir las imagenes
      await Promise.all(
        partidas
          .map((partida) => {
            // Crear nueva partida
            const nuevaPartida = partida;

            if (nuevaPartida.imagenes.length <= 0) {
              nuevaPartida.imagenes = null;
            }

            return nuevaPartida;
          })
          // Filtrar partidas que tengan imagenes
          .filter(({ imagenes }) => imagenes !== null)
          .map(async (partida) => {
            // Crear nueva partida
            const nuevaPartida = partida;
            // Obtener imagenes anteriores
            const imagenesAnteriores = partida.imagenes.filter((imagen) => typeof (imagen) === 'string');
            // Obtener nuevas imagenes agregadas
            let imagenesNuevas = partida.imagenes
              .filter((imagen) => typeof (imagen) === 'object');
            if (imagenesNuevas.length <= 0) {
              imagenesNuevas = null;
            }
            // Subir las imagenes
            const imagenes = await this.mixSubirImagenes(imagenesNuevas);
            // Si se subieron las imagenes
            if (imagenes) {
              // se agregan las imagenes nuevas a las anteriores.
              const imagenesTodas = [...imagenesAnteriores, ...imagenes];
              nuevaPartida.imagenes = imagenesTodas;
            } else {
              // Si no se subieron imagenes nuevas se conseran solo las anteriores.
              nuevaPartida.imagenes = [...imagenesAnteriores];
            }
            // Regresar la nueva partida
            return nuevaPartida;
          }),
      );

      // Convertir el array de de imagenes a string
      const partidasFormateadas = partidas.map((partida) => ({
        ...partida,
        imagenes: Array.isArray(partida.imagenes)
          ? JSON.stringify(partida.imagenes)
          : null,
      }));

      reporteFisico.partidas = partidasFormateadas;

      // set Avance programado
      this.reporteFisico.avanceProgramado = this.getAvanceProgramado;
      // set Avance Fisico
      this.reporteFisico.avanceFisico = this.getSumarAvancePoderado;

      // Guardar el reporte
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_REPORTE_FISICO,
          variables: {
            id: this.ultimoReporteFisico.id,
            reporteFisico,
          },
          update: (store, { data: { actualizarContratoReporteFisico } }) => {
            const query = {
              query: CONTRATO_REPORTES_FISICOS,
              variables: {
                idContrato,
              },
            };
            const data = store.readQuery(query);
            const { contratoReportesFisicos } = data;
            const index = contratoReportesFisicos
              .findIndex((item) => item.id === actualizarContratoReporteFisico.id);
            if (index !== -1) {
              contratoReportesFisicos.splice(index, 1, actualizarContratoReporteFisico);
            }
            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
          this.cerrar();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      await this.$apollo.queries.contratoCatalogoConceptosPartidas.refetch({
        idContrato,
      });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },
    async actualizarComentarisDireccion() {
      const { id } = this.reporte;
      this.mixEsCargando();
      this.enviadoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_REPORTE_FISICO_COMENTARIOS_DIRECCION,
          variables: {
            id,
            comentariosDireccion: this.comentariosDireccion,
          },
          update: (store, { data: { actualizarContratoReporteFisicoComentariosDireccion } }) => {
            const query = {
              query: CONTRATO_REPORTES_FISICOS_TODOS,
            };

            const data = store.readQuery(query);
            const { contratosReportesFisicosTodos } = data;
            const index = contratosReportesFisicosTodos
              .findIndex((item) => item.id === id);
            if (index !== -1) {
              contratosReportesFisicosTodos.splice(
                index,
                1,
                actualizarContratoReporteFisicoComentariosDireccion,
              );
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviadoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEliminarReporteFisico() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      const { id, idContrato } = this.reporteFisicoEliminar;

      await this.$apollo
        .mutate({
          mutation: REMOVER_CONTRATO_REPORTE_FISICO,
          variables: {
            id,
          },
          update: (store) => {
            const query = {
              query: CONTRATO_REPORTES_FISICOS,
              variables: {
                idContrato,
              },
            };
            const data = store.readQuery(query);
            const { contratoReportesFisicos } = data;
            const index = contratoReportesFisicos
              .findIndex((reporte) => reporte.id === id);
            if (index !== -1) {
              contratoReportesFisicos.splice(index, 1);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      await this.$apollo.queries.contratoCatalogoConceptosPartidas.refetch({
        idContrato,
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrarEliminar();
    },
    async mixSubirImagenes(imagenes) {
      if (!imagenes) return null;
      const formData = new FormData();
      [...imagenes].forEach((img) => formData.append('imagenes', img));
      const options = { headers: { 'Content-Type': 'multipart/form-data' } };
      const { publicKeys } = await this.axios
        .post(`${this.$urlFileServer}/multiples-imagenes`, formData, options)
        .then((res) => ({ publicKeys: res.data }))
        .catch((err) => ({ err }));
      if (!publicKeys) return null;
      return publicKeys;
    },
  },
  computed: {
    mixGetCatalogoConceptosPartidas() {
      if (!this.contratoCatalogoConceptosPartidas) return [];

      return [...this.contratoCatalogoConceptosPartidas].map((partida) => {
        const ultimoReporte = partida.reportes.find(({ esUltimo }) => esUltimo === true);
        const importeHijos = partida.hijos.reduce((total, elem) => total + elem.importe, 0);

        return {
          ...partida,
          avanceFisico: ultimoReporte?.avanceFisico || 0,
          ponderadoPartida: ((importeHijos / this.importeContratoCostoDirecto) * 100),
          avancePonderado: ultimoReporte?.avancePonderado || 0,
          ultimoReporte,
        };
      });
    },
  },
};
